export const CLIENT_ID = 'CLIENT_ID';
export const TKN = 'TKN';
